import React from 'react';

import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import { GLOBALS } from "../../../services/globals";


const BrokerageErrorPage = ({ headline = 'We are having technical issues redirecting to your brokerage account(s).' }) => {
  return (
    <ErrorPage summaryMessage={headline}>
      <div className="sso-form-error-message">
        Please <a className={'link'} href={`${GLOBALS.AAM_UI_EXTERNAL_BASE_URL}/personal-investing/help/contact/index.html`} target="_self" rel="noreferrer">contact us</a> or try again later.
      </div>
    </ErrorPage>
  );
};

export default BrokerageErrorPage;
